export default function quickEquals(newValue, oldValue) {
	if (newValue === oldValue) {
		return true;
	}

	// If its a primitive and doesnt match we should bail out before going further
	if (isPrimitiveOrNull(newValue) || isPrimitiveOrNull(oldValue)) return false;

	// Trying to rule out anything that might cause false positive for typeof === object later on
	if (!supportedType(newValue)) return false;
	if (!supportedType(oldValue)) return false;

	if (!quickEqualsType(newValue, oldValue)) return false;
	if (quickEqualsEmptyValue(oldValue, newValue)) return true;

	if (Array.isArray(newValue)) {
		const {length: newValueLength} = newValue;
		const {length: oldValueLength} = oldValue;
		if (newValueLength !== oldValueLength) return false;
		if (newValueLength > 10) return false;
		if (newValueLength < 1) return false;

		for (let i = 0; i < newValueLength; i++) {
			if (!isPrimitiveOrNull(newValue[i]) || !isPrimitiveOrNull(oldValue[i])) {
				return false;
			} else if (newValue[i] !== oldValue[i]) {
				return false;
			}
		}

		return true;
	} else if (typeof newValue === 'object') {
		const keys = Object.keys(newValue);
		const {length: newKeyLength} = keys;
		const {length: oldKeyLength} = Object.keys(oldValue);

		if (newKeyLength !== oldKeyLength) return false;
		if (newKeyLength > 6) return false;
		for (let key in keys) {
			key = keys[key];
			if (isPrimitive(newValue[key]) && isPrimitive(oldValue[key])) {
				if (newValue[key] !== oldValue[key]) {
					return false;
				}

				continue;
			} else if (isUndefinedOrNull(newValue[key]) || isUndefinedOrNull(oldValue[key])) {
				return false;
			} else if (
				Object.keys(newValue[key]).length === 2 &&
				Object.keys(oldValue[key]).length === 2
			) {
				const currentKeys = Object.keys(newValue[key]);
				const current1 = newValue[key][currentKeys[0]];
				const current2 = newValue[key][currentKeys[1]];
				const old1 = oldValue[key][currentKeys[0]];
				const old2 = oldValue[key][currentKeys[1]];
				if (
					!isPrimitiveOrNull(current1) ||
					!isPrimitiveOrNull(current2) ||
					!isPrimitiveOrNull(old1) ||
					!isPrimitiveOrNull(old2)
				) {
					return false;
				} else if (current1 !== old1 || current2 !== old2) {
					return false;
				}
			} else {
				return false;
			}
		}
		return true;
	}

	return false;
}

export function supportedType(value) {
	if (value instanceof Set) {
		return false;
	} else if (value instanceof Map) {
		return false;
	} else if (typeof value === 'function') {
		return false;
	} else if (Object.getOwnPropertySymbols(value).length > 0) {
		return false;
	} else if (value instanceof HTMLElement) {
		return false;
	} else if (value instanceof DOMRect) {
		return false;
	}

	return true;
}

function isPrimitiveOrNull(value) {
	return isPrimitive(value) || isUndefinedOrNull(value);
}

function isPrimitive(value) {
	const type = typeof value;
	if (type === 'object' || type === 'function') return false;

	if (type === 'string') return true;
	if (type === 'bigint') return true;
	if (type === 'boolean') return true;
	if (type === 'number') return true;
	if (type === 'symbol') return true;
	return false;
}

function isUndefinedOrNull(value) {
	return value === null || value === undefined;
}

const quickEqualsType = (newValue, oldValue) => {
	if (typeof newValue !== typeof oldValue) return false;
	else if (Array.isArray(newValue) !== Array.isArray(oldValue)) return false;
	return true;
};

const quickEqualsEmptyValue = (newValue, oldValue) => {
	if (Object.keys(newValue).length == 0 && Object.keys(oldValue).length == 0) return true;
	return false;
};
